<div class="px-4 py-2 d-flex">
  <h2 class="d-flex gap-2">
    <a (click)="onCancel()">
      <app-svg-icon [type]="model.openedFromDashboard ? 'tiles' : 'arrow-left'" size="large"/>
    </a>
    <span>{{ headerTitle | translate }}</span>
    <a *ngIf="headerHelpLink" class="link ps-2" data-gatm="global.label.help" (click)="openHELPLink(headerHelpLink)"
       tooltip
       tooltipPosition="bottom"
       [tooltipText]="'global.label.help' | translate"><app-svg-icon type="information_circle" [inline]="true"/></a>
  </h2>
</div>
<p class="modal-title-message px-4" [innerHTML]="headerText | translate"></p>

<ul *ngIf="visibleFeatures.tabs" class="nav nav-tabs large px-3" data-testid="project-navigation-folder-tabs">
  <li class="nav-item" data-testid="project-navigation-tab-my-projects">
    <a class="nav-link" (click)="openTabCurrentUser()" [class.active]="model.currentTab === Tab.Own"
       appActionLogId="projectNavigation.tab.my_projects"
       aria-current="page">{{ 'projectNavigation.my_projects' | translate }}</a>
  </li>
  <li class="nav-item" data-testid="project-navigation-tab-recently-used"
      *ngIf="visibleFeatures.recentlyUsedProjects && !model.compositeCheckBoxValue">
    <a class="nav-link" (click)="openTabRecentlyUsedProjects()"
       [class.active]="model.currentTab === Tab.RecentlyUsed" appActionLogId="projectNavigation.tab.recently_used_projects">
      {{ 'projectNavigation.recently_used_projects' | translate }}</a>
  </li>
  <li *ngIf="visibleFeatures.pinnedProjects && !model.compositeCheckBoxValue" class="nav-item">
    <a class="nav-link" data-testid="project-navigation-tab-favorites" (click)="openTabPinnedProjects()"
       [class.active]="model.currentTab === Tab.Pinned" appActionLogId="projectNavigation.tab.pinned_projects">
      {{ 'projectNavigation.pinned_projects' | translate }}</a>
  </li>
  <li *ngIf="model.isMyAssignedProjectsPresented && !model.compositeCheckBoxValue" class="nav-item">
    <a class="nav-link" data-testid="project-navigation-tab-assigned-to-me" (click)="openTabAssignedProjects()"
       [class.active]="model.currentTab === Tab.MyAssigned" appActionLogId="projectNavigation.tab.my_assigned_projects">
      {{ 'projectNavigation.my_assigned_projects' | translate }}</a>
  </li>
  <li *ngIf="model.currentModel.visibleSharedProjects" class="nav-item">
    <a class="nav-link" data-testid="project-navigation-tab-shared-with-me" (click)="openTabSharedUser()"
       [class.active]="model.currentTab === Tab.Shared" appActionLogId="projectNavigation.tab.shared_projects">{{
        'projectNavigation.shared_projects' |
          translate
      }}</a>
  </li>
  <li *ngIf="visibleFeatures.dialogSearch" class="nav-item">
    <a class="nav-link d-flex gap-2 align-items-center" data-testid="project-navigation-tab-search" style="padding-top: 11px !important;" (click)="openTabSearch()"
       [class.active]="model.currentTab === Tab.Search" appActionLogId="projectNavigation.tab.search">
      <app-svg-icon type="search" size="medium-large"/>
      <span>{{'global.label.search' | translate}}</span>
    </a>
  </li>
</ul>

<div class="modal-body project-navigation noselect d-flex flex-column pt-0" [class.save-new]="isNewProject()">
  <div class="fixed-fluid flex-grow-1 flex-column px-4 pt-3">

    <div data-testid="project-navigation-context-buttons" class="item-actions-header d-flex gap-3 align-items-center flex-wrap py-3 font-weight-bold">
      <ng-container *ngIf="visibleFeatures.projectGroupContextMenu">
        <a class="d-flex gap-1 align-items-center"
           data-testid="edit-project-button"
           [class.disabled]="!actionsService.isEditEnabled(model)"
           (click)="actionsService.edit(model)"
            appActionLogId="projectNavigation.context-action.">
          <app-svg-icon type="edit-pen"/>
          <span>{{ 'global.label.edit' | translate }}</span>
        </a>
        <a class="d-flex gap-1 align-items-center"
           data-testid="delete-project-button"
           [class.disabled]="!actionsService.isDeleteEnabled(model)"
           (click)="actionsService.delete(model)"
            appActionLogId="projectNavigation.context-action.delete">
          <app-svg-icon type="delete"/>
          <span>{{ 'global.label.remove' | translate }}</span>
        </a>
        <a class="d-flex gap-1 align-items-center"
           data-testid="copy-project-button"
           [class.disabled]="!actionsService.isCopyEnabled(model)"
           (click)="actionsService.copy(model)"
            appActionLogId="projectNavigation.context-action.copy">
          <app-svg-icon type="copy"/>
          <span>{{ 'global.label.copy' | translate }}</span>
        </a>
        <a class="d-flex gap-1 align-items-center"
           data-testid="move-project-button"
           [class.disabled]="!actionsService.isMoveEnabled(model)"
           (click)="actionsService.move(model)"
            appActionLogId="projectNavigation.context-action.move">
          <app-svg-icon type="move"/>
          <span>{{ 'global.label.move' | translate }}</span>
        </a>
        <a class="d-flex gap-1 align-items-center"
           data-testid="change-owner-project-button"
           *ngIf="userCanReassignProjects()"
           [class.disabled]="!actionsService.isChangeOwnerEnabled(model)"
           (click)="actionsService.changeOwner(model)"
            appActionLogId="projectNavigation.context-action.change-owner">
          <app-svg-icon type="user"/>
          <span>{{'global.label.reassign' | translate}}</span>
        </a>
        <a class="d-flex gap-1 align-items-center"
           data-testid="hide-project-button"
           [class.disabled]="!actionsService.isToggleVisibilityEnabled(model)"
           (click)="actionsService.toggleVisibility(model)"
            appActionLogId="projectNavigation.context-action.toggle-visibility">
          <app-svg-icon [type]="model.currentSelectedItem?.isHidden ? 'view' : 'no-view'"/>
          <span>{{ model.currentSelectedItem?.isHidden ? ('projectNavigation.label.show' | translate) : ('projectNavigation.label.hide' | translate)}}</span>
        </a>
        <div class="vr"></div>
      </ng-container>
        <a class="d-flex gap-1 align-items-center"
           data-testid="project-navigation-new-folder"
           appActionLogId="projectNavigation.new-folder"
           *ngIf="visibleFeatures.newFolderBtn"
           [class.disabled]="isAddProjectGroupDisabled()"
           (click)="newFolder()">
          <app-svg-icon type="add-folder"/>
          <span>{{ 'editProjectGroup.title.new' | translate }}</span>
        </a>
        <a data-testid="project-navigation-new-project"
           appActionLogId="projectNavigation.new-project-from-header"
           class="d-flex gap-1 align-items-center"
           *ngIf="isNewConfigurationGroupButtonVisible()"
           [class.disabled]="isAddProjectGroupDisabled()"
           (click)="newProjectGroup()">
          <app-svg-icon type="plus"/>
          <span>{{ 'editProjectGroup.title.new_project' | translate }}</span>
        </a>
    </div>

    <hr *ngIf="visibleFeatures.tabs || visibleFeatures.breadcrumbs" class="m-0"/>

    <div class="d-flex space-between py-3">
      <div class="d-flex flex-column gap-3">
        <ol *ngIf="visibleFeatures.breadcrumbs" class="dialog-breadcrumb activate-last m-0"
            data-testid="project-navigation-breadcrumbs">
          <li *ngIf="model.searchMode" class="d-inline">
            <app-svg-icon type="search" size="medium-small" class="d-inline pe-4"/>
            <a (click)="navigateToSearchRoot()">{{ 'sidebar.search.header' | translate }} {{model.searchText ? '"' + model.searchText + '"' : ""}}</a>
          </li>
          <ng-container *ngFor="let projectGroup of model.navigationChain; let i = index">
            <li class="d-inline">
              <a (click)="navigateInChain(projectGroup)">
                {{ getBreadcrumbLabel(projectGroup, i) }}
              </a>
            </li>
            <li *ngIf="projectGroup.groupName === ProjectNavigationModel.ROOT_NAME_SHARED && model.currentFilterItem" class="d-inline">
              <a (click)="navigateInChain(projectGroup)">
                <i class="mdi mdi-account"></i>
                {{ model.currentFilterItem.name }}
              </a>
            </li>
          </ng-container>
          <li *ngIf="model.currentViewedProjectGroup">
            <span class="project-badge" data-testid="project-badge">{{ model.currentViewedProjectGroup.groupName }}</span>
          </li>
        </ol>

        <div *ngIf="model.currentViewedProjectGroup && selectionAvailable" style="scale: 1.25; font-size: 0.72rem"
             class="form-check checkbox pe-2 mx-3 c-pointer d-flex align-self-start font-weight-bold"
             (click)="toggleSelectAllProjects($event, model.currentViewedProjectGroup)">
          <input #selectAllCheckbox [indeterminate]="allSelectedState == 'some'"
                 [checked]="allSelectedState == 'all'" type="checkbox" class="pe-none form-check-input" id="select-all"/>
          <label class="pe-none form-check-label c-pointer" for="select-all">{{ 'projectNavigation.label.select_all' | translate }}</label>
        </div>

      </div>
      <div class="d-flex gap-3 align-items-center justify-content-end flex-grow-1">
        <a *ngIf="model.currentTab === Tab.Own"
           data-testid="project-navigation-toggle-hidden"
           appActionLogId="projectNavigation.toggle-show-hidden"
           (click)="toggleShowHiddenItems()"
           tooltip [tooltipText]="'projectNavigation.hidden_projects' | translate">
          <app-svg-icon [type]="showHiddenItems ? 'view' : 'no-view'"/>
        </a>
        <div class="dropdown" dropdown #dropdown="bs-dropdown">
          <span class="d-flex align-items-center gap-1" data-toggle="dropdown" dropdownToggle>
            <a (click)="switchSortOrder()">
              <app-svg-icon [type]="this.currentSortingState.ascending ? 'arrow-up' : 'arrow-down'"/>
            </a>
            <a>{{ 'projectNavigation.label.sorting' | translate }}</a>
          </span>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" [class.text-primary]="this.currentSortingState.type == projectNavigationSortingType.NAME"
               (click)="onSortingChanged(projectNavigationSortingType.NAME)" appActionLogId="projectNavigation.sort.by-name">
              {{ "projectNavigation.label.sorting_name" | translate }}
            </a>
            <a class="dropdown-item" [class.text-primary]="this.currentSortingState.type == projectNavigationSortingType.ARTICLE_NUMBER" *ngIf="model.currentViewedProjectGroup"
               (click)="onSortingChanged(projectNavigationSortingType.ARTICLE_NUMBER)" appActionLogId="projectNavigation.sort.by-article-number">
              {{ "projectNavigation.label.sorting_article_number" | translate }}
            </a>
            <a class="dropdown-item" [class.text-primary]="this.currentSortingState.type == projectNavigationSortingType.DATE" *ngIf="model.currentViewedProjectGroup"
               (click)="onSortingChanged(projectNavigationSortingType.DATE)" appActionLogId="projectNavigation.sort.by-date">
              {{ "projectNavigation.label.sorting_date" | translate }}
            </a>
            <a class="dropdown-item" [class.text-primary]="this.currentSortingState.type == projectNavigationSortingType.STATUS" *ngIf="model.currentViewedProjectGroup"
               (click)="onSortingChanged(projectNavigationSortingType.STATUS)" appActionLogId="projectNavigation.sort.by-status">
              {{ "projectNavigation.label.status" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="fluid d-flex flex-column overflow-scrolling-touch">
      <app-project-navigation-search
        [model]="model"
        [visibleFeatures]="visibleFeatures"
        (searchEvent)="performSearch($event)" />

      <div *ngIf="(model.currentViewedProjectGroup && model.currentViewedProjectGroup.projects?.length != 0) || model.searchMode"
           [style.padding-left]="model?.currentTab == Tab.Shared && !model?.compositeCheckBoxValue ? '225px !important' : '0'"
           [style.margin-left]="model?.searchMode ? '32px' : '0'"
           class="label-headers font-weight-bold information-label d-flex px-2 gap-3">
        <span class="item-name"></span>
        <span class="item-user" *ngIf="!model.searchMode">{{ 'projectNavigation.label.modification_by' | translate }}</span>
        <span class="item-article-number">{{ 'projectNavigation.label.sorting_article_number' | translate }}</span>
        <span class="item-modification-date">{{ 'projectNavigation.label.modification_date' | translate }}</span>
        <span class="item-status">{{ 'projectNavigation.label.status' | translate }}</span>
      </div>

      <app-project-navigation-result
        *ngIf="!loadingTab"
        class="d-flex flex-grow-1"
        [model]="model"
        [visibleFeatures]="visibleFeatures"
        [selectionAvailable]="selectionAvailable"
        [showHiddenItems]="showHiddenItems"
        [multipleSelectionWithinSingleProject]="multipleSelectionWithinSingleProject"
        [isNewProjectCreation]="isNewProjectCreation"
        (cancel)="cancel.emit()"
        (actionButtonClick)="onActionBtnClick()"
        (submitEnabled)="updateSubmitEnabled()"
        (openFolder)="openFolder($event)"
        (openProject)="openProject($event)"
        (updateViewItems)="updateViewItems()" />

    </div>
  </div>
</div>

<span *ngIf="!submitEnabled && whySubmitDisabled" class="text-danger font-weight-bold p-3 pt-2 pb-0">{{ whySubmitDisabled | translate }}</span>

<app-project-navigation-save-block
  class="saveBlock"
  [model]="model"
  [itemToMoveOrCopy]="itemToMoveOrCopy"
  (submitEnabledChanged)="updateSubmitEnabled()"
></app-project-navigation-save-block>

<div class="modal-footer project-navigation">
  <div class="text-start me-auto">
    <span *ngIf="selectionAvailable">{{model.selectedProjectGroups.size()}} Selected Configurations: {{model.selectedProjects.size()}}</span>
    <div class="form-check" *ngIf="visibleFeatures.compositeCheckBox">
      <input type="checkbox" class="form-check-input" id="loadAsCompositeCheckBox"
             [(ngModel)]="model.compositeCheckBoxValue" (change)="compositeCheckBoxChanged()"/>
      <label class="form-check-label" for="loadAsCompositeCheckBox" data-testid="load-as-composite-check-box-label">
        {{ compositeCheckBoxLabel | translate }}
      </label>
    </div>
  </div>
  <button type="button" class="btn btn-cancel btn-secondary" (click)="onCancel()" data-testid="projectnavigation-cancel">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary btn-forward component-action" (click)="onActionBtnClick()"
          [class.event-disabled]="!submitEnabled" [disabled]="!submitEnabled" id="projectnavigation-submit"
          data-testid="projectnavigation-submit">
    {{ actionButtonLabel | translate }}
  </button>
</div>
